if (!window.Eurus.loadedScript.has('preview-color-swatches.js')) {
  window.Eurus.loadedScript.add('preview-color-swatches.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCard', (
        sectionId,
        productUrl,
        productId,
      ) => ({
        isSelect: false,
        productId: productId,
        showOptions: false,
        init() {          
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}:${productUrl}`, (e) => {
            this.checkVariantSelected();
          });
        },
        checkVariantSelected() {
          const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
          if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
            this.isSelect = true;
          }
        }
      }));
    })
  });

  this.$nextTick(() => {
  requestAnimationFrame(() => {
    const product_template = document.getElementById(
      `x-product-template-${productId}-${sectionId}`
    );

    if (!product_template) return;

    const priceElement = product_template.querySelector('.target-price');
    const offerPrice = product_template.querySelector('.discount-line .offer-price');

    if (!priceElement || !offerPrice) return;

    const price = Number(priceElement.textContent.trim());

    if (!Number.isFinite(price)) return;

    const money_format = currencyCodeEnable ? moneyWithCurrency : moneyFormat;

    offerPrice.innerHTML = Alpine.store('xHelper').formatMoney(
      price * 0.9,
      money_format
    );
  });
});
}    